import { Component, forwardRef } from '@angular/core'
import { ConfigurationOptionSelectComponent } from './configuration-option-select.component'
import { Observable, of } from 'rxjs'
import { formatNumber } from '@angular/common'
import { LocaleService } from '../../../../../../framework/locale/services/locale.service'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
    selector: 'mg-configuration-option-select-km-per-year',
    templateUrl: './configuration-option-select.component.html',
    styleUrls: ['./configuration-option-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionSelectKmPerYearComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionSelectKmPerYearComponent),
            multi: true,
        },
    ],
})
export class ConfigurationOptionSelectKmPerYearComponent extends ConfigurationOptionSelectComponent {
    constructor(public localeService: LocaleService) {
        super(localeService)
    }

    labelDisplay(option: string): Observable<string> {
        const optionNumber = formatNumber(parseInt(option) || 0, this.localeService.locale)

        let result = ''

        if (this.localeService.language === 'nl') {
            result = `${optionNumber} kilometer`
        } else if (this.localeService.language === 'fr') {
            result = `${optionNumber} kilomètres`
        } else {
            result = `${optionNumber} km`
        }

        return of(result)
    }
}
